import { FC, useRef } from 'react';

import V3Icon, { IconProps as V3IconProps } from 'app/components/v3/components/Icon';

import Box, { BoxProps } from '../Box';
import Icon, { IconProps } from '../Icon';
import Tooltip, { TooltipProps } from '../Tooltip';

// Local Typings
interface BaseProps {
  containerProps?: BoxProps;
  iconProps?: IconProps;
  tooltipProps: Omit<TooltipProps, 'childRef' | 'children'>;
  v3IconProps?: V3IconProps;
}
interface V2Props extends BaseProps {
  iconProps?: IconProps;
  v3IconProps?: never;
}
interface V3Props extends BaseProps {
  iconProps?: never;
  v3IconProps?: V3IconProps;
}
export type TooltipIconProps = V2Props | V3Props;

// Component Definition
const TooltipIcon: FC<TooltipIconProps> = ({
  containerProps,
  iconProps,
  tooltipProps,
  v3IconProps,
}) => {
  const spanRef = useRef<HTMLSpanElement>(null);

  return (
    <Tooltip
      childRef={spanRef}
      {...tooltipProps}
    >
      <Box
        as="span"
        display="flex"
        ref={spanRef}
        {...containerProps}
      >
        {v3IconProps
          ? (
            <V3Icon
              {...v3IconProps}
            />
          )
          : (
            <Icon
              name="old-information"
              {...iconProps}
            />
          )}
      </Box>
    </Tooltip>
  );
};

export default TooltipIcon;
